import { render, staticRenderFns } from "./head-box.vue?vue&type=template&id=28d5fee2"
import script from "./head-box.vue?vue&type=script&lang=js"
export * from "./head-box.vue?vue&type=script&lang=js"
import style0 from "./head-box.vue?vue&type=style&index=0&id=28d5fee2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports